import { BASE, AUTH } from '../../utils/service-providers';

export const LOGIN_ENDPOINT = `${AUTH}/authentication/authenticate`;
export const PASSWORD_TOKEN_ENDPOINT = (token: string) =>
  `${BASE}/auth/password/${token}`;
export const FORGOT_PASSWORD_ENDPOINT = `${BASE}/auth/password/reset`;
export const SIGNUP_ENDPOINT = (invitationCode: string) =>
  `${BASE}/auth/signup/${invitationCode}`;
export const VALIDATE_INVITE_ENDPOINT = (invitationCode: string) =>
  `${BASE}/auth/validate/${invitationCode}`;
export const IMPERSONATE_ENDPOINT = `${AUTH}/authentication/impersonate`;
export const VERIFY_TFA_ENDPOINT = `${AUTH}/authentication/tfa/verify`;
export const GENERATE_TFA_ENDPOINT = `${BASE}/auth/tfa/generate`;
export const VALIDATE_RETRY_TOKEN_ENDPOINT = (token: string) =>
  `${BASE}/auth/validate/retry/${token}`;
export const GENERATE_LOGIN_OTP = `${BASE}/auth/one-time-password/generate`;
export const VALIDATE_LOGIN_OTP = `${AUTH}/authentication/one-time-password/validate`;
export const REFRESH_TOKEN = `${AUTH}/authentication/refresh/token`;
export const GENERATE_LOGIN_LINK = `${BASE}/auth/login-link/generate`;
export const VALIDATE_LOGIN_LINK = `${AUTH}/authentication/login-link/validate`;
